<template>
    <div class="table-responsive">
        <table class="table">
            <thead>
                <tr class="head-0">
                    <slot name="head-row-0"></slot>
                </tr>
                <tr class="head-1">
                    <slot name="head-row-1"></slot>
                </tr>
                <tr class="head-2">
                    <slot name="head-row-2"></slot>
                </tr>
            </thead>
            <slot name="body"></slot>
        </table>
    </div>
</template>
<script>
export default {};
</script>
<style scoped lang="scss">
@import "../../css/forecasts.scss";
.table-wrapper {
    max-width: 1800px;
    overflow: auto;
}
table {
    text-transform: uppercase;
    border-spacing: 0;
    border-collapse: collapse;
    white-space: nowrap;
    width: calc(100% - 2px);
    background-color: white;
    .head-0 {
        th {
            border: none;
        }
    }
    .head-1 {
        background-color: $table_color_1;
        color: $color4;
    }
    .head-2 {
        th {
            font-size: 16px !important;
            &.preseries {
                text-align: center;
                font-size: 14px !important;
                background-color: #ffa7b3;
            }
        }
        background-color: #b2b1b1;
        color: $color4;
    }
    .selection-head > div {
        display: inline;
        &title {
            padding-right: 30px;
        }
    }

    tbody {
        border: 1px solid #bcbdbd;
    }

    td {
        font-size: 16px;
        padding: 15px 7.5px;
        text-align: center;
        vertical-align: middle;
    }
    .odd {
        background-color: $color6;
    }
    tr {
        border-bottom: none;
        //background-color: $color4;
    }
}
</style>



// WEBPACK FOOTER //
// ForecastTable.vue?16647838